import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ArrowLink } from 'site-modules/shared/components/arrow-link/arrow-link';
import { EventToolbox } from 'client/utils/event-toolbox';
import { FINANCING_EVENTS } from 'site-modules/shared/constants/financing/financing-events';

export function PrequalifiedCta({
  isBasicView = false,
  link = '',
  isMobile = false,
  activeStep = '',
  isMatchingVIN = false,
  isPreVinFlow = false,
}) {
  const handleClick = () => {
    EventToolbox.fireCustomEvent(FINANCING_EVENTS.LOOK_IT_UP_CLICK, { isMatchingVIN, step: activeStep, isPreVinFlow });
  };
  return (
    <div
      className={classNames('text-center', isBasicView ? 'mt-2' : 'mt-3', {
        'd-flex justify-content-center': isBasicView && !isMobile,
      })}
    >
      <h2 className="size-16 text-gray-darker">Already pre-qualified with Capital One?</h2>
      <ArrowLink className="ms-0_25 fw-bold" id="look-up-rates" to={link} onClick={handleClick}>
        Look it up
      </ArrowLink>
    </div>
  );
}

PrequalifiedCta.propTypes = {
  isBasicView: PropTypes.bool,
  link: PropTypes.string,
  isMobile: PropTypes.bool,
  activeStep: PropTypes.string,
  isMatchingVIN: PropTypes.bool,
  isPreVinFlow: PropTypes.bool,
};
